import { FC } from 'react'
import { Alert } from '@mui/material'
import { Sensor } from 'src/api'
import { DEF_PERIOD } from 'src/config/constants'

const DEACTIVATED_MESSAGE = 'This sensor is deactivated. Please sign in to the ThingSpace platform to activate it.'
const CONFIG_ISSUES_MESSAGE = 'Some configuration issues detected. Please reconfigure a sensor using "Configure Sensor" button.'

export const isSensorDeactivated = (sensor: Sensor): boolean =>
  sensor.thingspaceSensor?.activationStatus === 'deactive'

export const hasSensorConfigIssues = (sensor: Sensor): boolean =>
  sensor.currentConfig?.temperatureMonitorPeriod == null ||
  sensor.currentConfig?.commPeriodSet !== DEF_PERIOD ||
  sensor.currentConfig?.commSynchPeriod !== DEF_PERIOD

export const SensorAlerts: FC<{ sensor: Sensor }> = ({ sensor }) => (
  <>
    {isSensorDeactivated(sensor) && (
      <Alert severity="error" sx={{ mb: 2 }}>{DEACTIVATED_MESSAGE}</Alert>
    )}
    {hasSensorConfigIssues(sensor) && (
      <Alert severity="error" sx={{ mb: 2 }}>{CONFIG_ISSUES_MESSAGE}</Alert>
    )}
  </>
)
